module.exports = "/_next/static/images/899e6273f08e8f44484a03265fab0c45-card-new.svg";